import type { RequestParams } from '@/shared/api';
import type { CategoryItemListParams } from '../model/types';

export const CATEGORY_KEYS = {
  all: ['category'] as const,
  list: (params?: RequestParams) => [...CATEGORY_KEYS.all, 'list', params] as const,
  detail: (id: number | string) => [...CATEGORY_KEYS.all, 'detail', id] as const,
  itemList: (params?: CategoryItemListParams) => [...CATEGORY_KEYS.all, 'item-list', params] as const,
};
